// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CreateCustomerRepoManager from "../repo/CreateCustomerRepoManager.bs.js";

function createdCustomer(customer, country, onSuccess, onFailure) {
  var RepoInstance = CreateCustomerRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.createCustomer, customer, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  createdCustomer ,
  
}
/* CreateCustomerRepoManager Not a pure module */
